import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBolt,
  faCircleCheck,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import "../../Styles/s2s-aside.scss";

const DEFAULT_ITEMS = [
  {
    icon: faBolt,
    title: "Instant Transfer",
    description: "Money arrives in seconds",
  },
  {
    icon: faCircleCheck,
    title: "Zero Fees",
    description: "No charges, ever",
  },
  {
    icon: faClock,
    title: "24/7 Available",
    description: "Send anytime, any day",
  },
];

export default function S2SAside({
  title = "Why Suyool to Suyool?",
  items = DEFAULT_ITEMS,
}) {
  return (
    <div className="new-s2s-side-card">
      <h3>{title}</h3>
      <div className="new-s2s-side-card__list">
        {items.map((item) => (
          <div key={item.title} className="new-s2s-side-card__item">
            <span className="new-s2s-side-card__icon" aria-hidden="true">
              <FontAwesomeIcon icon={item.icon} />
            </span>
            <div>
              <strong>{item.title}</strong>
              <p>{item.description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
